<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
					formControlName="name" placeholder="">
				<label for="name">Profile Name*</label>
			</div>
			<p *ngIf="showError('name')" class="text-danger">
				<span *ngIf="f.name.errors?.required">
					Required
				</span>
				<span *ngIf="f.name.errors?.incorrect">
					{{customError.name}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<label>Age Limit*:</label>
			<br />
			<mat-radio-group aria-label="Select an option" formControlName="age">
				<mat-radio-button [name]="'age'" ngDefaultControl [value]="0" [color]="'primary'">
					Above 18
				</mat-radio-button>
				<mat-radio-button [name]="'age'" ngDefaultControl [value]="1" [color]="'primary'">
					Below 18
				</mat-radio-button>
			</mat-radio-group>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<label>Doctor Interaction Required</label>
			<mat-checkbox style="width: 100%;" color="primary" id="is_videocall" formControlName="is_videocall">
				Video Call
			</mat-checkbox>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('description')}" id="description"
					formControlName="description" placeholder=""></textarea>
				<label for="description">Description*</label>
			</div>
			<p *ngIf="showError('description')" class="text-danger">
				<span *ngIf="f.description.errors?.required">
					Required
				</span>
				<span *ngIf="f.description.errors?.incorrect">
					{{customError.description}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<ng-select id="scale" [items]="scaleList" bindLabel="scale_name" bindValue="scale_id" [clearable]="true"
				placeholder="Scale" formControlName="scale" [multiple]="true" appearance="outline">
				<ng-template ng-label-tmp let-item="item">
					<button type="button" (click)="deselectById(item.scale_id)">
						<fa-icon [icon]="['fas', 'times']"></fa-icon>
					</button>
					{{item.scale_name}}
				</ng-template>
				<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
					{{item.scale_name}}({{item.Cat_name}})
				</ng-template>
			</ng-select>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>